export const getFastFormSubmitAction = (state) => state.fastFormSubmit;
